/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
import { customElement } from 'solid-element';
import Rightpanel, {
  RightpanelProps,
  IRightpanelFooterButton,
} from './Rightpanel';
import { ICustomElement, noShadowDOM } from 'component-register';

// TypeScript declaration for the web component
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tc-rightpanel': Partial<HTMLElement> &
        RightpanelProps &
        Partial<{ ref: ICustomElement }>;
    }
  }
}

export function defineSolidRightpanel(): void {
  customElement(
    'tc-rightpanel',
    {
      header: undefined,
      headerTitle: undefined,
      topLeftButton: undefined,
      topRightPrimaryButton: undefined,
      topRightSecondaryButton: undefined,
      footer: undefined,
      sectionProps: undefined,
      bodyProps: undefined,
      content: undefined,
    },
    (props, { element }) => {
      noShadowDOM();

      function handleFooterButtonClick(
        button: IRightpanelFooterButton,
        event: MouseEvent
      ): void {
        const evt = new CustomEvent('rightpanel-footer-btn-click', {
          detail: {
            originalEvent: event,
            buttonText: button.text,
            buttonClass: button.class,
            buttonProps: button.props,
          },
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      function handleLeftButtonClick(): void {
        const evt = new CustomEvent('rightpanel-left-btn-click', {
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      function handlePrimaryButtonClick(): void {
        const evt = new CustomEvent('rightpanel-primary-btn-click', {
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      function handleSecondaryButtonClick(): void {
        const evt = new CustomEvent('rightpanel-secondary-btn-click', {
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      return (
        <Rightpanel
          header={props.header}
          headerTitle={props.headerTitle}
          topLeftButton={props.topLeftButton}
          topRightPrimaryButton={props.topRightPrimaryButton}
          topRightSecondaryButton={props.topRightSecondaryButton}
          footer={props.footer}
          sectionProps={props.sectionProps}
          bodyProps={props.bodyProps}
          content={props.content}
          onFooterButtonClick={handleFooterButtonClick}
          onLeftButtonClick={handleLeftButtonClick}
          onPrimaryButtonClick={handlePrimaryButtonClick}
          onSecondaryButtonClick={handleSecondaryButtonClick}
        />
      );
    }
  );
}
